import { Link } from "react-router-dom";
import { usePlatform } from "@/lib/platform";

export const CrownMark = ({ className = "" }) => (
  <svg viewBox="0 0 64 50" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="aetryx-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FFF1B8" />
        <stop offset="0.35" stopColor="#FFD86A" />
        <stop offset="0.65" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#8A6A1F" />
      </linearGradient>
    </defs>
    <path d="M6 15 L19 27 L32 7 L45 27 L58 15 L53 39 H11 Z" fill="url(#aetryx-gold)" stroke="#FFE9A3" strokeWidth="0.8" strokeLinejoin="round" />
    <path d="M26.5 31 L32 22.5 L37.5 31 L32 35.5 Z" fill="#050505" opacity="0.6" />
    <rect x="11" y="41.5" width="42" height="5" rx="1.5" fill="url(#aetryx-gold)" />
    <circle cx="6" cy="12.5" r="3.2" fill="url(#aetryx-gold)" />
    <circle cx="32" cy="5" r="3.5" fill="url(#aetryx-gold)" />
    <circle cx="58" cy="12.5" r="3.2" fill="url(#aetryx-gold)" />
  </svg>
);

export const Logo = ({ size = "md", to = "/", testId = "brand-logo" }) => {
  const big = size === "lg";
  const p = usePlatform();
  if (p.logo_url) return <Link to={to} data-testid={testId} className="flex flex-none items-center select-none"><img src={p.logo_url} alt={p.name} className={big ? "h-12 max-w-[220px] object-contain" : "h-8 sm:h-9 max-w-[160px] object-contain"} /></Link>;
  return (
    <Link to={to} data-testid={testId} className="group flex items-center gap-2 sm:gap-2.5 select-none flex-none">
      <CrownMark className={`${big ? "h-10 w-12" : "h-7 w-8 sm:h-8 sm:w-10"} drop-shadow-[0_0_10px_rgba(212,175,55,0.55)] transition-transform duration-500 group-hover:-translate-y-0.5`} />
      <span className="flex flex-col leading-none">
        <span className={`font-display gold-sheen tracking-[0.16em] ${big ? "text-[2rem]" : "text-lg sm:text-[1.35rem]"}`} style={{ fontWeight: 800 }}>
          {(p.name || "AETRYX").toUpperCase()}
        </span>
        <span className={`flex items-center gap-1.5 font-display text-[#D4AF37]/85 tracking-[0.45em] ${big ? "text-[0.7rem] mt-1.5" : "text-[0.5rem] sm:text-[0.56rem] mt-1"}`}>
          AI STUDIOS
        </span>
      </span>
    </Link>
  );
};
